/* eslint-disable @typescript-eslint/no-explicit-any */
export const requestIdleCallback = (typeof window !== 'undefined' &&
    window.requestIdleCallback &&
    window.requestIdleCallback.bind(window)) ||
    ((callback) => {
        const start = Date.now();
        return setTimeout(() => {
            callback({
                didTimeout: false,
                timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
            });
        }, 1);
    });
export const execAfterUserInteraction = (cb, timeout) => {
    let hasInteracted = false;
    let timeoutId;
    const clearTimeoutId = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = undefined;
        }
    };
    if (hasInteracted) {
        cb();
        clearTimeoutId();
        return;
    }
    if (timeout) {
        timeoutId = setTimeout(() => {
            if (!hasInteracted) {
                cb();
                clearTimeoutId();
            }
        }, timeout);
    }
    const listener = () => {
        if (hasInteracted) {
            return;
        }
        hasInteracted = true;
        cb();
        clearTimeoutId();
        for (const eventName of USER_ACTIVITY_EVENTS) {
            document.removeEventListener(eventName, listener);
        }
    };
    for (const eventName of USER_ACTIVITY_EVENTS) {
        document.addEventListener(eventName, listener, true);
    }
};
const USER_ACTIVITY_EVENTS = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart'
];
